/* global axios */
import ApiClient from './ApiClient';

class BroadcastsApi extends ApiClient {
  constructor() {
    super('broadcasts', { accountScoped: true });
  }

  get() {
    return axios.get(`${this.baseUrl()}/broadcasts`);
  }

  getActive() {
    return axios.get(`${this.baseUrl()}/broadcasts/running`);
  }

  create(broadcastParams) {
    return axios.post(`${this.baseUrl()}/broadcasts`, broadcastParams);
  }

  resolveTarget(targetParams) {
    return axios.post(
      `${this.baseUrl()}/broadcast_target_resolutions`,
      targetParams
    );
  }

  previewTargets(targetSpec) {
    return axios.post(`${this.baseUrl()}/broadcast_target_previews`, {
      target_spec: targetSpec,
    });
  }

  getTemplates() {
    return axios.get(`${this.baseUrl()}/broadcast_templates`);
  }

  getTemplate(templateId) {
    return axios.get(`${this.baseUrl()}/broadcast_templates/${templateId}`);
  }

  createTemplate(templateParams) {
    return axios.post(`${this.baseUrl()}/broadcast_templates`, templateParams);
  }

  updateTemplate(templateId, templateParams) {
    return axios.patch(
      `${this.baseUrl()}/broadcast_templates/${templateId}`,
      templateParams
    );
  }

  deleteTemplate(templateId) {
    return axios.delete(`${this.baseUrl()}/broadcast_templates/${templateId}`);
  }

  getBlacklist() {
    return axios.get(`${this.baseUrl()}/broadcast_blacklist_entries`);
  }

  addToBlacklist(inputType, values) {
    return axios.post(`${this.baseUrl()}/broadcast_blacklist_entries`, {
      broadcast_blacklist_entry: { input_type: inputType, values },
    });
  }

  removeFromBlacklist(entryId) {
    return axios.delete(
      `${this.baseUrl()}/broadcast_blacklist_entries/${entryId}`
    );
  }
}

export default new BroadcastsApi();
